import React, { Component } from "react"
import { getJSON } from "../../../shared_component/utils/fetch"
import { connect } from "react-redux"
import { partition } from "lodash"
import {
  selectShop,
  makeShopsApiCall,
  setPrevShopSearchParams,
  setMakeShopsApiCallData
} from "../../actions/shop"
import { signIn, setLoading, setNotLoading } from "../../actions/user"
import { clearPromotionParam } from "../../actions/promotion"
import store from "../../../shared_component/utils/configureStore"
import CarBar from "../CarBar"
import Geosuggest from "react-geosuggest"
import CartPanel from "../Cart/CartPanel"
import GenericPanel from "../GenericPanel"
import "url-search-params-polyfill"
import ShopList from "./ShopList"
import ShopList2 from "../../CarAdvise2/screens/dashboard/components/ShopList2"
import ShopMapView from "./ShopMapView"
import { getShopAddress, getShopName, withPricing } from "../../helpers/shopHelpers"
import { sortByAttr } from "../../../shared_component/utils/arrayHelpers"
import { Grid, Select } from "semantic-ui-react"
import BreadcrumbNav from "../../components/BreadcrumbNav"
import { DASHBOARD, SERVICES, SCHEDULE, CHECKOUT } from "../../components/BreadcrumbNav"
import NotificationModal from "../../components/Modal/NotificationModal"
import GatherZipModal from "../../components/Modal/GatherZipModal"
import { HIDE_NOTIFICATION_MODAL } from "../../constants/reduxActions"
import SplitClient, { ON, CARADVISE_2_MAP, setupSplitFlags } from "../Config/SplitClient"
import { GAEvent, GAEventCategories } from "../../tracking/GAEvent"
import { withTranslation } from "react-i18next"
import {
  getUrlParams,
  getUrlWithoutParams,
  ADDING_INSPECTION_PARAM
} from "../../../shared_component/utils/urlUtils"
import { isCanada } from "../../helpers/translationHelpers"
import { routerPaths } from "../../constants/paths"
import { trackEvent } from "../../../shared_component/utils/segmentAnalytics"
import { getActiveVehicle, getVehicleName } from "../../helpers/vehicleHelpers"
import DisplayMessage from "./DisplayMessage"
import { MAP_1, MAP_2, RATING_TAG } from "../../constants/shops"
import { APP_NAME } from "../../../shared_component/constants/common"
import { shopSelectedEvents } from "../../../shared_component/utils/googleAnalyticsHelpers"
const FIND_SHOPS_URL = "/api/v4/shops/select_shops"
const LIST_VIEW = "listView"
const MAP_VIEW = "mapView"
export const DISTANCE = "distance"
export const PRICE = "price"
let count = 1
function getRegion(shop) {
  return {
    latitude: shop.latitude,
    longitude: shop.longitude,
    latitudeDelta: 0.1,
    longitudeDelta: 0.1
  }
}

// This component has grown to the point of needing to be broken up.
// TODO: extract functionality to helper functions or smaller components, API calls to /actions
class SelectShop extends Component {
  constructor(props) {
    super(props)

    const gatherZipModalOpen = !!Boolean(getUrlParams(ADDING_INSPECTION_PARAM))
    if (gatherZipModalOpen) {
      window.history.replaceState(null, null, getUrlWithoutParams([ADDING_INSPECTION_PARAM]))
    }

    const user = props.user || {}

    this.state = {
      zip: "",
      shops: [],
      selectedShop: null,
      selectedCompany: null,
      geolocationFinished: true,
      prevShopSearchParams: {},
      shopsLoaded: false,

      // default latitude/longitude is for Toronto or Chicago
      region: {
        latitude: isCanada(user.country) ? 43.6390608 : 41.8786673,
        longitude: isCanada(user.country) ? -79.4199158 : 87.6428121,
        latitudeDelta: 0.0922,
        longitudeDelta: 0.0421
      },

      searchLocation: null,

      selectedView: MAP_VIEW,
      sortAttr: DISTANCE,

      loading: false,
      shopLoading: false,
      notificationModalOpen: false,
      gatherZipModalOpen: gatherZipModalOpen,
      showNewMap: false,
      ratingFiltersApplied: [],
      typeFiltersApplied: []
    }
    this.fetchShops.bind(this)
    this._handleSubmit = this._handleSubmit.bind(this)
    this._handleInput = this._handleInput.bind(this)
    this._handleSuggestSelect = this._handleSuggestSelect.bind(this)
  }

  async componentDidMount() {
    this.mounted = true
    window.scrollTo(0, 0)

    if (this.props.modalNotifications.message) this.openNotificationModal()

    await setupSplitFlags.bind(this)({
      callback: (flags = {}) => {
        if (!this.state.gatherZipModalOpen) this.fetchInitialData()
      }
    })
  }

  async componentDidMount() {
    this.fetchInitialData()
  }

  addorRemoveFilterItem(value, filterType) {
    const { latitude, longitude, zip } = this.state.prevShopSearchParams

    const selectedType =
      filterType == RATING_TAG
        ? this.state.ratingFiltersApplied.slice()
        : this.state.typeFiltersApplied.slice()
    if (filterType == RATING_TAG) {
      const index = selectedType.findIndex((i) => i == value)
      if (index > -1) {
        selectedType.splice(0, selectedType.length)
      } else {
        selectedType.splice(0, selectedType.length)
        if (value == 2) {
          selectedType.push(2, 3, 4, 5)
        } else if (value == 3) {
          selectedType.push(3, 4, 5)
        } else if (value == 4) {
          selectedType.push(4, 5)
        } else if (value == 5) {
          selectedType.push(5)
        }
      }
    } else {
      const index = selectedType.findIndex((i) => i == value)
      if (index > -1) {
        selectedType.splice(index, 1)
      } else {
        selectedType.push(value)
      }
    }
    if (filterType == RATING_TAG) {
      this.setState({
        ratingFiltersApplied: selectedType
      })
      this.fetchShops({ latitude, longitude, zip, rating: selectedType })
    } else {
      this.setState({
        typeFiltersApplied: selectedType
      })
      this.fetchShops({ latitude, longitude, zip, appointmentType: selectedType })
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const { addedServices, user } = this.props
    // If the user removes a service from the cart, we need to refetch shops to recalculate pricing
    if (prevProps !== this.props) {
      if (
        prevProps.user.zip !== user.zip ||
        prevProps.addedServices.length !== addedServices.length
      ) {
        this.setState({ shopLoading: true })
        await this.makeShopsApiCall1({
          ...this.state.prevShopSearchParams,
          services_requested: this.servicesParam(),
          vehicle_id: this.props.user.activeVehicleId
        })
        this.props.setPrevShopSearchParams(this.state.prevShopSearchParams)
        this.setState({ shopLoading: false })
      }
    }
  }

  openGatherZipModal = () => {
    this.setState({ gatherZipModalOpen: true })
  }

  closeGatherZipModal = () => {
    this.setState({ gatherZipModalOpen: false })
    this.fetchInitialData()
  }

  openNotificationModal = () => {
    this.setState({ notificationModalOpen: true })
  }

  closeNotificationModal = () => {
    this.setState({ notificationModalOpen: false })
    store.dispatch({ type: HIDE_NOTIFICATION_MODAL })
  }

  handleApplyFilterClick = (rating, bookingType, clearFilters = false) => {
    const { latitude, longitude, zip } = this.state.prevShopSearchParams
    this.setState({
      ratingFiltersApplied: rating,
      typeFiltersApplied: bookingType
    })
    this.fetchShops({
      latitude,
      longitude,
      zip,
      rating: rating,
      appointmentType: bookingType,
      clearFilters: clearFilters
    })
  }

  clearAllFilters = () => {
    const { latitude, longitude, zip } = this.state.prevShopSearchParams
    this.setState({
      ratingFiltersApplied: [],
      typeFiltersApplied: []
    })
    this.fetchShops({ latitude, longitude, zip, clearFilters: true })
  }

  fetchInitialData() {
    const { user } = this.props
    const queryParams = new URLSearchParams(this.props.location.search)

    if (!user.authentication_token) return

    if (user.zip) {
      this.fetchShops({ zip: user.zip }, false)
    } else if (queryParams.get("lat") && queryParams.get("lng")) {
      this.fetchShopsFromParams(queryParams)
    } else {
      this.fetchShopsFromUsersLocation()
    }
  }

  fetchShopsFromParams(queryParams) {
    const latitude = queryParams.get("lat")
    const longitude = queryParams.get("lng")

    this.setState(
      {
        searchLocation: {
          latitude,
          longitude
        }
      },
      () => {
        this.fetchShops({ latitude, longitude }, false)
      }
    )
  }

  async fetchShopsFromUsersLocation() {
    this.setState({ geolocationFinished: false })
    if (navigator && navigator.permissions && navigator.geolocation) {
      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        if (result.state === "granted" || result.state === "prompt") {
          navigator.geolocation.getCurrentPosition(
            (data) => {
              const { latitude, longitude } = data.coords
              this.fetchShops({ latitude, longitude }, false)
            },
            (error) => {
              this.getDefaultShops()
            }
          )
        } else {
          this.getDefaultShops()
        }
      })
    } else {
      this.getDefaultShops()
    }
  }

  getDefaultShops() {
    const { region } = this.state
    const { latitude, longitude } = region
    this.fetchShops({ latitude, longitude }, false)
  }

  servicesParam() {
    const services = this.props.addedServices.map((sd) => {
      return { position: sd.position, service_definition_id: sd.id }
    })

    return JSON.stringify(services)
  }

  async fetchShops(
    {
      latitude,
      longitude,
      zip,
      rating = undefined,
      appointmentType = undefined,
      clearFilters = false
    },
    fullReload = true
  ) {
    if (this.state.loading) {
      return
    }
    const { t } = this.props
    this.setState({ geolocationFinished: true })
    fullReload && this.props.setLoading(t("findingShopsLoadingMessage"))

    this.setState({ loading: true })

    let params = {
      services_requested: this.servicesParam(),
      vehicle_id: this.props.user.activeVehicleId
    }

    if (clearFilters) {
      params.rating = "[]"
      params.booking_type = "[]"
    } else {
      if (rating != undefined) {
        params.rating = JSON.stringify(rating)
      } else if (this.state.ratingFiltersApplied && this.state.ratingFiltersApplied.length > 0) {
        params.rating = JSON.stringify(this.state.ratingFiltersApplied)
      }
      if (appointmentType != undefined) {
        params.booking_type = JSON.stringify(appointmentType)
      } else if (this.state.typeFiltersApplied && this.state.typeFiltersApplied.length > 0) {
        params.booking_type = JSON.stringify(this.state.typeFiltersApplied)
      }
    }
    const { promoCode } = this.props
    if (promoCode) params["promo_code"] = promoCode

    if (zip) {
      params.zip = zip
    } else if (latitude && longitude) {
      // Set lat & long in params
      params.latitude = latitude
      params.longitude = longitude
    } else {
      fullReload && this.props.setNotLoading()
      return
    }
    await this.makeShopsApiCall1(params)

    fullReload && this.props.setNotLoading()
    this.setState({ loading: false })
  }

  makeShopsApiCall1 = async (params) => {
    if (!(params.latitude && params.longitude) && !params.zip) params.zip = this.props.user.zip
    this.setState({ shopsLoaded: true })
    const response = await getJSON(FIND_SHOPS_URL, params, {
      Authorization: this.props.user.authentication_token
    })

    if (response.result && !response.result.errors) {
      this.props.setMakeShopsApiCallData(response.result)
      const shops = withPricing(this.props.shops || [], this.props.t)
      this.setState({
        shops,
        region: shops[0] ? getRegion(shops[0]) : this.state.region,
        selectedShop: null,
        prevShopSearchParams: params
      })
    } else {
    }
  }

  _handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.fetchShops({})
  }

  _handleSuggestSelect(suggest) {
    if (suggest) {
      this.setState(
        {
          searchLocation: {
            name: suggest.label,
            latitude: suggest.location.lat,
            longitude: suggest.location.lng
          }
        },
        () => {
          this.fetchShops(this.state.searchLocation, false)
        }
      )
    }
  }

  async componentDidMount() {
    const { user } = this.props
    const showNewMap = await SplitClient.getTreatments([CARADVISE_2_MAP], user, {
      app_name: APP_NAME
    })
    this.fetchInitialData()
    await this.setState({
      showNewMap: showNewMap[CARADVISE_2_MAP]
    })
  }

  async shouldComponentUpdate(nextProps) {
    // Rendering the component only if
    // passed props value is changed
    if (nextProps.addedServices.length < this.props.addedServices.length) {
      this.setState({ loading: true })
      await this.makeShopsApiCall1({
        ...this.state.prevShopSearchParams,
        services_requested: JSON.stringify(
          nextProps.addedServices.map((sd) => {
            return { position: sd.position, service_definition_id: sd.id }
          })
        ),
        vehicle_id: this.props.user.activeVehicleId
      })
      this.setState({ loading: false })
    } else {
      return false
    }
  }
  handleShopPreSelect = (shop) => {
    this.setState({ selectedShop: shop })
  }

  handleShopSelect = (shop, pricingInfo) => {
    this.setState({ selectedShop: shop })
    const { promoCode, cart, t, activeVehicle } = this.props
    const hasNoServices = (cart.order_services || []).length === 0
    const { showNewMap } = this.state
    const mapVersion = showNewMap && showNewMap === ON ? MAP_2 : MAP_1
    // TODO: (JH) Is there a better way to accomplish this other than the callback?
    // We don't want to navigate to /schedule until the API calls from selectShop are finished.
    let opts = {
      successCallback: async (response) => {
        await shopSelectedEvents({ response, shop, activeVehicle })
        await trackEvent("click-service-center", {
          shopAddress: getShopAddress(response.shop),
          shopCity: response.shop && response.shop.city,
          shopName: getShopName({
            shop: response.shop,
            company: response.shop && response.shop.company
          }),
          shopId: response.shop && parseInt(response.shop.id),
          mapVersion: mapVersion
        })
        store.dispatch(clearPromotionParam())
        if (hasNoServices) {
          this.props.history.push(routerPaths.services)
        } else {
          this.props.history.push(routerPaths.schedule)
        }
      }
    }
    if (promoCode) opts.promoCode = promoCode
    store.dispatch(selectShop(shop, opts))
  }

  handleCompanySelect = (company, shop) => {
    this.setState({ selectedCompany: company, selectedView: MAP_VIEW, selectedShop: shop })
  }

  toggleView = (view) => {
    if (this.state.selectedView === view) return
    GAEvent(GAEventCategories.SELECT_SHOP, `shop-toggle-${view}`, `Shop Toggle ${view}`)
    this.setState({ selectedView: view, selectedShop: null })
  }

  filteredSortedShops = () => {
    const { shops, isFixedPrice, selectedCompany, sortAttr } = this.state
    let filteredShops
    if (selectedCompany && selectedCompany.independent) {
      filteredShops = shops.filter(
        (shop) => shop.company.independent && shop.company.paid === selectedCompany.paid
      )
    } else if (selectedCompany) {
      filteredShops = shops.filter((shop) => shop.company_id === selectedCompany.id)
    } else {
      filteredShops = shops
    }

    if (sortAttr === PRICE) {
      let partitioned = partition(filteredShops, (s) => s["shopPriceEstimate"] != null)
      let withPrices = partitioned[0]
      let nullPrices = partitioned[1]

      let sorted = sortByAttr(withPrices, "shopPriceEstimate")
      sorted = sorted.concat(sortByAttr(nullPrices, "distance"))

      return sorted
    } else {
      return sortByAttr(filteredShops, "distance")
    }
  }

  renderEmptyState(vehicleTypeId) {
    const { loading, geolocationFinished } = this.state
    const { t } = this.props
    let message = t("noShopFoundMessage")
    if (!geolocationFinished) message = t("findingYourLocationMessage")
    else if (loading) message = t("loadingShopsMessage")

    return (
      <>
        <DisplayMessage message={t("common:mdHdShopsLabel")} vehicleTypeId={vehicleTypeId} />
        <div className="shops-empty-state">{message}</div>
      </>
    )
  }

  renderShopsList(preparedShops, vehicleTypeId) {
    if (preparedShops.length === 0 || this.state.loading) {
      return this.renderEmptyState(vehicleTypeId)
    } else {
      const { sortAttr } = this.state
      return (
        <ShopList
          sortedShops={preparedShops}
          onSelect={this.handleCompanySelect}
          shouldDisplayPrice={this.props.addedServices.length > 0}
          orderServices={this.props.cart.order_services}
          vehicleTypeId={vehicleTypeId}
        />
      )
    }
  }

  renderShopsMap = (preparedShops, vehicleTypeId) => {
    const { selectedShop, loading } = this.state
    if (preparedShops.length === 0 || loading) {
      return this.renderEmptyState(vehicleTypeId)
    } else {
      return (
        <ShopMapView
          onSelect={this.handleShopSelect}
          onPreSelect={this.handleShopPreSelect}
          shops={preparedShops}
          shouldDisplayPrice={this.props.addedServices.length > 0}
          selectedShop={selectedShop || preparedShops[0]}
          orderServices={this.props.cart.order_services}
          vehicleTypeId={vehicleTypeId}
        />
      )
    }
  }

  renderNewMap = (preparedShops) => {
    const {
      ratingFiltersApplied,
      typeFiltersApplied,
      sortAttr,
      selectedShop,
      searchLocation
    } = this.state
    return (
      <ShopList2
        handleShopSelect={this.handleShopSelect}
        shops={preparedShops}
        addorRemoveFilterItem={(value, type) => this.addorRemoveFilterItem(value, type)}
        clearAllFilters={this.clearAllFilters}
        ratingFiltersApplied={ratingFiltersApplied}
        typeFiltersApplied={typeFiltersApplied}
        sortingType={sortAttr}
        loading={this.state.loading}
        shopLoading={this.state.shopLoading}
        updateSortingType={(value) => {
          this.setState({ sortAttr: value, selectedShop: null })
        }}
        onSuggestSelect={this._handleSuggestSelect}
        zip={this.props.user.zip}
        handleApplyFilterClick={this.handleApplyFilterClick}
        searchLocation={searchLocation}
      />
    )
  }

  renderViewSelector = () => {
    const { selectedView } = this.state
    const { t } = this.props
    return (
      <div className="selectShopViewSelect">
        <span
          className={selectedView === LIST_VIEW ? "" : "underlinePrimaryLink"}
          onClick={() => {
            this.setState({ selectedCompany: null })
            this.toggleView(LIST_VIEW)
          }}
        >
          {t("listViewLbl")}
        </span>
        {` | `}
        <span
          className={selectedView === MAP_VIEW ? "" : "underlinePrimaryLink"}
          onClick={() => this.toggleView(MAP_VIEW)}
        >
          {t("mapViewLbl")}
        </span>
      </div>
    )
  }

  render() {
    const {
      selectedView,
      shops,
      selectedCompany,
      selectedShop,
      notificationModalOpen,
      gatherZipModalOpen,
      loading,
      showNewMap,
      ratingFiltersApplied,
      typeFiltersApplied,
      sortAttr
    } = this.state
    const { vehicle, modalNotifications, cart, user, t } = this.props
    const hasNoServices = this.props.addedServices.length === 0
    const preparedShops = this.filteredSortedShops()
    const hasAppointment = cart.is_walk_in || cart.appointment_datetime
    let vehicleTypeId
    if (user) {
      const activeVehicle = getActiveVehicle()
      vehicleTypeId = (activeVehicle && activeVehicle.vehicle_type_id) || null
    }
    return (
      <div className="dashContainer selectShop">
        {/* {this.state.loading && <ProgressHUD />} */}
        {gatherZipModalOpen && (
          <GatherZipModal
            isOpen={gatherZipModalOpen}
            closeModal={this.closeGatherZipModal}
            cart={cart}
            user={user}
          />
        )}
        <NotificationModal
          isOpen={notificationModalOpen}
          closeModal={this.closeNotificationModal}
          message={modalNotifications.message}
        />

        {vehicle && (
          <CarBar year={vehicle.year.value} make={vehicle.make.value} model={vehicle.model.value} />
        )}
        <div className="dashLeftContainer">
          <GenericPanel>
            <BreadcrumbNav
              back={hasNoServices ? DASHBOARD : SERVICES}
              forward={hasNoServices ? SERVICES : hasAppointment ? CHECKOUT : SCHEDULE}
              forwardDisabled={hasNoServices ? false : !cart.shop}
              currentName={t("selectShopText")}
              cartId={cart.id}
              makeShopApiCall={this.makeShopsApiCall1}
            />
            {showNewMap && showNewMap === ON ? (
              this.renderNewMap(preparedShops)
            ) : (
              <div>
                <Grid style={{ margin: 0, padding: 0 }}>
                  <Grid.Row columns={16} style={{ padding: 0 }}>
                    <Grid.Column width="10" style={{ paddingLeft: 0, paddingRight: 0 }}>
                      <Geosuggest
                        onFocus={() =>
                          GAEvent(GAEventCategories.SELECT_SHOP, "shop-search", "Shop Search Bar")
                        }
                        onSuggestSelect={this._handleSuggestSelect}
                        placeholder={t("enterAddressOrCityPlaceholder")}
                        types={["geocode"]}
                        country={user.country}
                        ignoreTab={true}
                        className="geosuggest-container"
                        suggestsClassName="search-suggests-list"
                        suggestItemClassName="search-suggest-item"
                        inputClassName={`searchFldShop smaller-width`}
                        suggestItemActiveClassName="search-suggest-item-active"
                        suggestsHiddenClassName="search-suggests-list-hidden"
                      />
                    </Grid.Column>
                    <Grid.Column
                      className="shopSort secondary-font"
                      floated="right"
                      width="5"
                      style={{ paddingRight: 0 }}
                    >
                      <Select
                        className="shopSortDropdown secondary-font"
                        fluid
                        options={[
                          { value: DISTANCE, text: t("distanceText") },
                          { value: PRICE, text: t("priceText"), disabled: hasNoServices }
                        ]}
                        defaultValue={DISTANCE}
                        onChange={(e, selection) =>
                          this.setState({ sortAttr: selection.value, selectedShop: null })
                        }
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                {this.renderViewSelector()}
                {loading && this.renderEmptyState(vehicleTypeId)}
                {!loading &&
                  selectedView === LIST_VIEW &&
                  this.renderShopsList(preparedShops, vehicleTypeId)}
                {!loading &&
                  selectedView === MAP_VIEW &&
                  this.renderShopsMap(preparedShops, vehicleTypeId)}
              </div>
            )}
          </GenericPanel>
        </div>
        <div className="dashRight">
          <CartPanel />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  let user = state.user
  let shops = state.shop.shops || []

  let cart =
    user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  let addedServices = cart ? cart.order_services : []
  let modalNotifications = state.modalNotifications
  const promotionData = state.promotionData

  return {
    addedServices,
    anyOrderServiceLacksPrice: cart && cart.any_order_service_lacks_price,
    promoCode: promotionData.promoCode,
    user,
    cart: cart || {},
    shops,
    modalNotifications
  }
}

export default connect(mapStateToProps, {
  selectShop,
  signIn,
  setLoading,
  setNotLoading,
  makeShopsApiCall,
  setMakeShopsApiCallData,
  setPrevShopSearchParams
})(withTranslation(["selectShop", "common"])(SelectShop))
